import { GalleryItemType } from './gallery.types';

export function getGalleryItemType(contentType?: string): GalleryItemType {
  // Unfortunately, the contentType is not always available so if it's not we should default to just FILE.
  // Potentially we could try to grab the type from the filename in the future.
  if (!contentType) {
    return GalleryItemType.FILE;
  }

  if (/^image\//.test(contentType)) {
    return GalleryItemType.PICTURE;
  }

  if (/^video\//.test(contentType)) {
    return GalleryItemType.VIDEO;
  }

  if (/^application\/pdf/.test(contentType)) {
    return GalleryItemType.PDF;
  }

  return GalleryItemType.FILE;
}

export function getDefaultGalleryItemsSortOrder(): {
  [GalleryItemType.PICTURE]: number;
  [GalleryItemType.VIDEO]: number;
  [GalleryItemType.PDF]: number;
  [GalleryItemType.FILE]: number;
} {
  return {
    [GalleryItemType.PICTURE]: 3,
    [GalleryItemType.VIDEO]: 2,
    [GalleryItemType.PDF]: 1,
    [GalleryItemType.FILE]: 0,
  };
}
